export default __webpack_public_path__ + "static/media/01.45ceeca4.png";